/*
  Filtering functions
*/

export function filterSuggestions (query, suggestions, field) {
  /* Filtering function for suggestions */
  field = field || 'value'
  const getf = typeof field === 'string' ? item => item[field] : field
  if (!query) {
    return suggestions.map(s => {
      return {
        ...s,
        right: getf(s),
      }
    })
  }
  query = query.toLowerCase()
  let out = [], seen = {}
  suggestions.forEach((s, i) => {
    if (getf(s).toLowerCase().substr(0, query.length) === query) {
      out.push({
        ...s,
        match: getf(s).substr(0, query.length),
        right: getf(s).substr(query.length),
      })
      seen[i] = true
    }
  })
  suggestions.forEach((s, i) => {
    if (seen[i]) return
    let index = getf(s).toLowerCase().indexOf(query)
    if (index > 0) {
      out.push({
        ...s,
        left: getf(s).substr(0, index),
        match: getf(s).substr(index, query.length),
        right: getf(s).substr(index + query.length),
      })
      seen[i] = true
    }
  })
  return out
}

export function orderSuggestions (query, suggestions, field) {
  /* Order suggestions by putting first the similar ones */
  field = field || 'value'
  const getf = typeof field === 'string' ? item => item[field] : field
  if (!query) {
    return suggestions.map(s => {
      return {
        ...s,
        right: getf(s),
      }
    })
  }
  query = query.toLowerCase()
  let priority = [], others = []
  suggestions.forEach(s => {
    let v = getf(s).toLowerCase()
    if (v.substr(0, query.length) === query) {
      priority.push({
        ...s,
        match: getf(s).substr(0, query.length),
        right: getf(s).substr(query.length),
      })
    } else if (query.substr(0, v.length) === v) {
      priority.push({
        ...s,
        match: getf(s),
      })
    } else {
      others.push({
        ...s,
        right: getf(s),
      })
    }
  })
  return [
    ...priority,
    ...others,
  ]
}
